var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('the-loader'),_c('the-sidebar'),_c('the-topbar'),_c('the-view'),_c('the-snackbar-stack')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }